// Intersection Observer setup
const observer = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      animateText(entry.target);
      observer.unobserve(entry.target);
    }
  });
}, {
  threshold: 0.1
});

// Observe elements with class 'animated-text'
document.querySelectorAll('.animated-text').forEach(el => {
  observer.observe(el);
});


function animateRow(row) {
  row.classList.add('show');
}

const rows = document.querySelectorAll('.trigger');

const trigger = new IntersectionObserver((entries, trigger) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      animateRow(entry.target);
      trigger.unobserve(entry.target);
    }
  });
}, {
  threshold: 0.1
});

rows.forEach(row => {
  trigger.observe(row);
});



const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'zoom-animate';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'observer--cancel';


// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const elements = document.querySelectorAll("img");

  if (elements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  elements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        if (entry.isIntersecting) {
          const el = entry.target;

          // Trigger animation
          el.classList.add("zoom-animate");
        }
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}
function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

initializeScrollZoomAnimationTrigger();
